<template>
  <img :src="generate" class="qrcode" alt="QR-Code" title="QR-Code"/>
</template>

<script>
  import Config from "@/vuex/Config";

  export default {
    name: 'QrCode',
    props: [
      'set'
    ],
    data() {
      return {
        appUrl: Config.getters.getAppUrl,
        qrCodeUri: window.conf2020AppConfig['qrCodeUrl'],
        configuratorUri: window.conf2020AppConfig['urlPrafix'],
        itemnumberUri: ''
      }
    },
    mounted() {
      this.createItemnumberUri();
      this.$root.$on('updateQrCode', () => {
        this.createItemnumberUri();
      });
    },
    beforeDestroy() {
      this.$root.$off('updateQrCode');
    },
    methods: {
      createItemnumberUri() {
        this.itemnumberUri = this.set.itemnumbers.join('/') + '/';
      }
    },
    computed: {
      generate: function () {
        let host = window.location.origin;
        if (Config.getters.getAppEnv === 'live') {
          host = 'https://www.' + Config.getters.getWebsite + '.' + Config.getters.getCountry;
        }
        const qrCodeUrl = host + this.configuratorUri + this.itemnumberUri;

        return host + this.qrCodeUri + '?s=qr&d=' + qrCodeUrl + '&sf=3&ms=r&md=0.8';
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  #app {
    .qrcode {
      width: 7.5rem;
    }
  }
</style>
